<template>
	<div>
		<!-- 功能按钮 -->
		<buttonlist @help="help" @opentable="opentable" @search="search" @reflash="reflash" @exps="exp" ref="SetBtn"></buttonlist>
		<!-- 功能按钮 -->
		<!-- 表格 -->
		<wTable
				id="xpane-0"
				:data="datajson"
				:loading="loading"
				queryData="MonChartInfo"
				:filter_thousandth="['Estimate_MoneyLastMouth','SendProduct_Money','Other_Money','ExRate_Dif','Invoice_Money','Data_Check','Discount_PA',
				'Discount_Dif','Discount_AccrueAdd','Discount_Accrue','Actual_Money','Estimate_Money']"
				:header="tableHeader"
				:option="tableOption"
				@handleSelectionChange="handleSelectionChange"
				ref="singleTable"
				:checkflg="false"
		></wTable>
		<!-- 表格 -->
		<!-- 分页 -->
		<el-row class="page">
			<el-col :span="18">
				<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[100, 200, 300, 400]"
						:page-size="PageSize"
						:pager-count="5"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
				></el-pagination>
			</el-col>
			<el-col :span="6">
				<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
			</el-col>
		</el-row>
		<!-- 分页 -->
		<serce :isVisible="isVisible" queryData="MonChartInfo" ref="ser" @getser="serclick"></serce>
		<ctable :isVisible="false" :title="$t('getapi[1016]')" queryData="MonChartInfo" tabNo="0" ref="ctab"
				@getctab="sortclick"></ctable>
		<!-- 搜索弹框 -->
	</div>
</template>

<script>
    import Common from '@/components/Common';
    export default {
        name: 'monchartinfo',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3,
                    maxHeight: this.$windowSize.tableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                showloading: '',
                isVisible: false,
                editvisi: false,
                DbTbNames: '', //表名
                datajson: [],
                PageIndex: 1,
                PageSize: this.$http.getPageSize('monchartinfo'),
                SelectIndex: 1,
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                isShowEdit: false, // 是否显示编辑页面
                dataSetDetail: {}, // 编辑页面数据详情
                queryData: [], // 查询数组
                selectIDData: '', // 选择的数据的ID集合
                tracetype: 0, //跟踪类别
                url: '', // 零件图路径
                isEdit: true, // 是否新增
                itevisible: false, //物料弹框
                rouvisible: false,
                roushowindex: 0,
                wcentervisible: false,
                wcentershowindex: 0,
                editf: false,
                scrollTop:0,
            };
        },
        create() {},
        beforeMount() {
            console.log('beforeMount');
            let that = this;
        },
        watch: {
            datajson: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted() {
            console.log('mounted');
            let that = this;
            that.colsort();
            //that.intidata();
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[13435]"),this.$t("getapi[14]"));
            },
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('MonChartInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            //按钮操作权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                //只读权
                if (that.$limits.authority('plv2', 122, 1) == 1) {
                    if (that.total > 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    } else {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                    }
                }

                //操作权
                let ilimits = that.$limits.OperationAuthorityView('plv2', 122, 1, that.total);
                // limits说明：、1 查询级、2 编辑权限、3 删除权限
                switch (ilimits) {
                    case -1:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        break;
                    case 1:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        break;
                    case -2:
                        that.$refs.SetBtn.SetButtonEnable(',search,refresh');
                        break;
                    case 2:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        break;
                    case -3:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        break;
                    case 3:
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        break;
                    default:
                        break;
                }
            },
            //获取查询条件
            serclick(val) {
                console.log(val);
                this.queryData = val;
                this.intidata();
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = '';
                for (let i = 0; i < val.length; i++) {
                    that.selectIDData += val[i].Co_id + ',';
                }
                console.log(that.selectIDData);
            },
            //修改页数
            handleSizeChange(val) {
                this.PageSize = val;
                this.$http.savePageSize('monchartinfo',val)
                this.intidata();
                this.authority();
            },
            //跳页
            handleCurrentChange(val) {
                this.PageIndex = val;
                this.intidata();
                this.authority();
            },
            // 获取数据
            intidata() {
                let that = this;
                that.loading = true;
                this.isVisible = false;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: '',
                    row_sign: '',
                    query_sort: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndexs,
                    Ids: '',
                    Param: []
                };
                that.queryData.forEach(item => {
                    pm = {
                        row_sign: item.row_sign,
                        query_Condition: item.query_Condition,
                        query_sort: item.query_sort,
                        query_field_type: item.Query_Field_Type,
                        query_field_name: item.Query_Field_Name
                    };
                    parm.Param.push(pm);
                });
                console.log(parm);
                that.$http.urlpost('/Finance/FrmSaleInvoice/Sal_MonthCountInfoTable', parm, function(res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.datajson = res.DataContent;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.loading = false;
                    that.authority();
                });
            },

            // 查询
            search() {
                this.isVisible = true;
                this.$refs.ser.clearInput(this.isVisible, 'MonChartInfo');
            },
            // 刷新
            reflash() {
                this.intidata();
            },
            //弹出框关闭前提示
            closemodel(e) {
                let that = this
                this.$confirm(that.$t('getapi[3655]'), that.$t('getapi[194]'), {//'数据已发生变更是否保存后关闭?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {})
                    .catch(() => {});
            },
            //导出·
            exp() {
                let that = this;
                that.loading=true;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: '',
                    row_sign: '',
                    query_sort: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: that.selectIDData,
                    Param: []
                };
                that.queryData.forEach(item => {
                    pm = {
                        row_sign: item.row_sign,
                        query_Condition: item.query_Condition,
                        query_sort: item.query_sort,
                        query_field_type: item.Query_Field_Type,
                        query_field_name: item.Query_Field_Name
                    };
                    parm.Param.push(pm);
                });
                that.$http.urlpost('/Finance/FrmSaleInvoice/Sal_MonthCountInfoTableExportToExecl', parm, function(res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    } else {
                        that.$message.error(res.Msg);
                    }
                    that.loading=false;
                });
            }
        }
    };
</script>

<style lang="scss" scoped></style>
